import { ShiftCanvasLogo } from "@/components/shiftcanvas-logo";

export function isAuthTransitioning(): boolean {
  try {
    return localStorage.getItem("auth_transitioning") === "true";
  } catch {
    return false;
  }
}

export function AuthTransitionLoader() {
  return (
    <div 
      className="min-h-screen bg-background flex flex-col items-center justify-center"
      data-testid="auth-transition-loader"
    >
      <div className="flex-1" />

      <div className="mb-6">
        <ShiftCanvasLogo variant="text-small" className="h-8 w-auto" data-testid="img-auth-loader-logo" />
      </div>
      
      <div className="pb-16 flex justify-center">
        <div className="flex gap-1.5">
          <span 
            className="w-2 h-2 rounded-full animate-bounce" 
            style={{ animationDelay: '0ms', backgroundColor: '#4ECDC4' }}
          />
          <span 
            className="w-2 h-2 rounded-full animate-bounce" 
            style={{ animationDelay: '150ms', backgroundColor: '#1B3A5C' }}
          />
          <span 
            className="w-2 h-2 rounded-full animate-bounce" 
            style={{ animationDelay: '300ms', backgroundColor: '#4ECDC4' }}
          />
        </div>
      </div>
    </div>
  );
}
